import { SectionTitles } from '@chiroup/core/enums/SectionTitles.enum';
import {
  FlexibleDisplayItem,
  FlexibleDisplaySection,
} from '@chiroup/core/functions/buildFlexibleDisplay';
import React from 'react';

interface ComplaintSummarySectionProps {
  section: FlexibleDisplaySection;
  sectionIndex: number;
  renderFlexibleDisplayItem: (item: FlexibleDisplayItem, itemIndex: number) => React.ReactNode;
  questionAnswerMaps?: Record<string, any>;
}

const ComplaintSummarySection: React.FC<ComplaintSummarySectionProps> = ({
  section,
  sectionIndex,
  renderFlexibleDisplayItem,
  questionAnswerMaps = {},
}) => {
  // //TODO I put this back in, we can do more checking to see if it is actually needed
  // const visibleItems = section.items.filter(item => {
  //   // Always show these sections regardless of content
  //   if (
  //     section.title === SectionTitles.YellowFlags ||
  //     section.title === SectionTitles.ProvocativeFactors ||
  //     section.title === SectionTitles.PalliativeFactors ||
  //     section.title === SectionTitles.Quality ||
  //     section.title === SectionTitles.AdditionalInformation ||
  //     section.title === SectionTitles.Onset ||
  //     section.title === SectionTitles.Timing ||
  //     section.title === SectionTitles.AutoAccidentDetails ||
  //     section.title === SectionTitles.WorkInjuryDetails ||
  //     section.title === SectionTitles.SymptomSpecifics ||
  //     section.title === SectionTitles.Overview ||
  //     section.title === SectionTitles.GeneralQuestions ||
  //     section.title === SectionTitles.Severity
  //   ) {
  //     return true;
  //   }

  //   return item.type === 'nested_section' && item.nestedItems && item.nestedItems.length > 0;
  // });

  // // The [None] item is now created in buildFlexibleDisplay, so we don't need special handling here
  // if (visibleItems.length === 0) {
  //   return null;
  // }

  return (
    <div key={sectionIndex}>
      <h4 className="font-medium text-lg  mt-2">
        {section.title !== SectionTitles.YellowFlags && section.title}
      </h4>
      <div className="prose prose-sm leading-normal space-y-2">
        {section.items.map((item, itemIndex) => (
          <div key={`${sectionIndex}-${itemIndex}`}>
            {renderFlexibleDisplayItem(item, itemIndex)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComplaintSummarySection;
